const NotFoundIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={300}
      height={308}
      viewBox="0 0 300 308"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <ellipse cx="150" cy="290.523" rx="150" ry="17.3355" fill="#3D5373" />
      <path
        d="M90 241.88C90 208.637 116.949 181.688 150.193 181.688C183.436 181.688 210.385 208.637 210.385 241.88V287.627H90V241.88Z"
        fill="#051F46"
      />
      <path
        d="M156.693 273.188C175.613 273.188 193.715 273.593 210.386 274.332V306.713C194.399 307.421 177.096 307.824 159.017 307.855H154.371C131.272 307.815 109.439 307.171 90.0001 306.054V274.992C110.089 273.838 132.735 273.188 156.693 273.188Z"
        fill="#051F46"
      />
      <circle cx="172.229" cy="263.409" r="12.4095" fill="white" />
      <circle cx="172.229" cy="265.878" r="3.87797" fill="#051F46" />
      <circle
        cx="12.4095"
        cy="12.4095"
        r="12.4095"
        transform="matrix(-1 0 0 1 140.819 251)"
        fill="white"
      />
      <circle
        cx="3.87797"
        cy="3.87797"
        r="3.87797"
        transform="matrix(-1 0 0 1 132.288 262)"
        fill="#051F46"
      />
      <mask
        id="mask0_1991_52880"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="54"
        y="16"
        width="192"
        height="235"
      >
        <path
          d="M243.981 202.517C246.788 207.238 244.111 213.319 238.733 214.438L64.0982 250.754C58.7204 251.873 53.841 247.363 54.5332 241.914L81.2784 31.3648C81.7087 27.9769 84.2422 25.2358 87.5858 24.5405L127.007 16.3424C130.351 15.6471 133.767 17.1509 135.513 20.0864L243.981 202.517Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1991_52880)">
        <rect
          x="-3.39288"
          y="43.4609"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 -3.39288 43.4609)"
          fill="#0D8091"
        />
        <rect
          x="14.2551"
          y="128.32"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 14.2551 128.32)"
          fill="#0D8091"
        />
        <rect
          x="5.43112"
          y="85.8906"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 5.43112 85.8906)"
          fill="white"
        />
        <rect
          x="23.0787"
          y="170.758"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 23.0787 170.758)"
          fill="white"
        />
        <rect
          x="31.9024"
          y="213.188"
          width="222.186"
          height="43.3387"
          transform="rotate(-11.7477 31.9024 213.188)"
          fill="#0D8091"
        />
      </g>
      <rect
        x="12.6914"
        y="257.836"
        width="287.619"
        height="26.0032"
        rx="13.0016"
        transform="rotate(-11.7477 12.6914 257.836)"
        fill="#0B6C7B"
      />
    </svg>
  );
};

export default NotFoundIcon;
